import { Route, Routes } from 'react-router-dom'
import { ShareholdersAndInvestors } from './stakeholders-and-investors/view/shareholders-and-investors'
import { BoardMembers } from './board-members/view/board-member'
import { AddStakeholder } from './stakeholders-and-investors/view/add-shareholder'
import { IndividualDetails } from './stakeholders-and-investors/view/individual-details'
import { InstitutionalDetails } from './stakeholders-and-investors/view/institutional-details'
import { AddBoardMember } from './board-members/view/add-board-member'
import { BoardMemberDetails } from './board-members/view/board-member-details'
import { ManagementTeam } from './management-team/view/management-team'
import { FoundersAndPromotors } from './founders-and-promoters/view/founders-and-promoters'
import { AddFounderPromoter } from './founders-and-promoters/view/add-founder-and-promoter'
import FounderandPromoterDetails from './founders-and-promoters/view/founder-and-promoter-details'
import { AddTeamMember } from './management-team/view/add-team-member'
import { TeamMemberDetails } from './management-team/view/team-member-details'
import { LegalAndCompliance } from './legal-and-compliance/view/legal-and-compliance'
import { AddLegalAndCompliance } from './legal-and-compliance/view/add-legal-and-compliance'
import IndividualLegalComplianceDetails from './legal-and-compliance/view/individual-legal-compliance-details'
import InstitutionalLegalComplianceDetails from './legal-and-compliance/view/institutional-legal-compliance-details'
import { FinanceAndAccounts } from './finance-and-accounts/view/finance-and-accounts'
import { AddFinanceAndAccounts } from './finance-and-accounts/view/add-finance-and-accounts'
import IndividualFinanceAccountsDetails from './finance-and-accounts/view/individual-finance-accounts-details'
import InstitutionalFinanceAccountsDetails from './finance-and-accounts/view/institutional-finance-accounts-details'
import { AdvisorsAndMentors } from './advisors-and-mentors/views/advisors-and-mentors'
import { AddAdvisorsAndMentors } from './advisors-and-mentors/views/add-advisors-and-mentors'
import IndividualAdvisorsMentorsDetails from './advisors-and-mentors/views/individual-advisors-mentors-details'
import InstitutionalAdvisorsMentorsDetails from './advisors-and-mentors/views/institutional-advisors-mentors-details'

const StakeholderRoutes = () => {
  return (
    <div className='mt-3 px-6'>
      <Routes>
        <Route
          path='stakeholders-and-investors'
          element={<ShareholdersAndInvestors />}
        />
        <Route
          path='add-stakeholder'
          element={
            <>
              <AddStakeholder />
            </>
          }
        />

        <Route
          path='individual-details/:shareholderId'
          element={
            <>
              <IndividualDetails />
            </>
          }
        />
        <Route
          path='institutional-details/:shareholderId'
          element={
            <>
              <InstitutionalDetails />
            </>
          }
        />
        <Route
          path='board-member'
          element={
            <>
              <BoardMembers />
            </>
          }
        />
        <Route
          path='add-board-member'
          element={
            <>
              <AddBoardMember />
            </>
          }
        />
        <Route
          path='board-member-details/:boardMemberId'
          element={
            <>
              <BoardMemberDetails />
            </>
          }
        />
        <Route
          path='founders-and-promoters'
          element={
            <>
              <FoundersAndPromotors />
            </>
          }
        />
        <Route
          path='add-founder-and-promoter'
          element={
            <>
              <AddFounderPromoter />
            </>
          }
        />
        <Route
          path='founder-and-promoter-details/:founderPromoterId'
          element={
            <>
              <FounderandPromoterDetails />
            </>
          }
        />
        <Route
          path='management-team'
          element={
            <>
              <ManagementTeam />
            </>
          }
        />
        <Route
          path='add-team-member'
          element={
            <>
              <AddTeamMember />
            </>
          }
        />
        <Route
          path='team-member-detail/:memberId'
          element={
            <>
              <TeamMemberDetails />
            </>
          }
        />
        <Route
          path='legal-and-compliance'
          element={
            <>
              <LegalAndCompliance />
            </>
          }
        />
        <Route
          path='add-legal-and-compliance'
          element={
            <>
              <AddLegalAndCompliance />
            </>
          }
        />
        <Route
          path='individual-legal-compliance-details/:legalCompilanceId'
          element={
            <>
              <IndividualLegalComplianceDetails />
            </>
          }
        />
        <Route
          path='institutional-legal-compliance-details/:legalCompilanceId'
          element={
            <>
              <InstitutionalLegalComplianceDetails />
            </>
          }
        />
        <Route
          path='finance-and-accounts'
          element={
            <>
              <FinanceAndAccounts />
            </>
          }
        />
        <Route
          path='add-finance-and-accounts'
          element={
            <>
              <AddFinanceAndAccounts />
            </>
          }
        />
        <Route
          path='individual-finance-accounts-details/:financeAccountsId'
          element={
            <>
              <IndividualFinanceAccountsDetails />
            </>
          }
        />
        <Route
          path='institutional-finance-accounts-details/:financeAccountsId'
          element={
            <>
              <InstitutionalFinanceAccountsDetails />
            </>
          }
        />
        <Route
          path='advisors-and-mentors'
          element={
            <>
              <AdvisorsAndMentors />
            </>
          }
        />
        <Route
          path='add-advisors-and-mentors'
          element={
            <>
              <AddAdvisorsAndMentors />
            </>
          }
        />
        <Route
          path='individual-advisors-and-mentors-details/:advisorMentorId'
          element={
            <>
              <IndividualAdvisorsMentorsDetails />
            </>
          }
        />
        <Route
          path='institutional-advisors-and-mentors-details/:advisorMentorId'
          element={
            <>
              <InstitutionalAdvisorsMentorsDetails />
            </>
          }
        />
      </Routes>
    </div>
  )
}

export default StakeholderRoutes
